export const useLogger = () => {
  const extractErrorData = (data: unknown) => {
    if (data instanceof Error) {
      return {
        message: data.message,
        name: data.name,
        stack: data.stack,
        ...(data as any),
      };
    }
    return data;
  };

  const submitLog = (message: string, data?: unknown) => {
    const processedData = extractErrorData(data);
    const logEvent: LogEvent = {
      event: "error",
      status: "ERROR",
      message,
      params: {
        data: JSON.stringify(processedData),
      },
    };
    $fetch("/api/log", {
      method: "POST",
      body: logEvent,
    });
  };

  const log = (logType: LogType, message: string, data: unknown = {}) => {
    const { debugMode } = useRuntimeConfig().public;
    const timestamp = `[${new Date().toISOString()}]`;
    const processedData = extractErrorData(data);
    const logText = `${timestamp} ${message} ${
      processedData ? JSON.stringify(processedData) : ""
    }`;

    if (debugMode) {
      switch (logType) {
        case "error":
          console.error(logText);
          break;
        case "warn":
          console.warn(logText);
          break;
        default:
          console.log(logText);
      }
    }

    if (logType === "error") submitLog(message, data);
  };

  return {
    submitLog,
    error: (message: string, data?: unknown) => log("error", message, data),
    warn: (message: string, data?: unknown) => log("warn", message, data),
    log: (message: string, data?: unknown) => log("log", message, data),
  };
};
